import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { Header, Panel, Whisper, Popover, Button, Text } from "rsuite";
import axios from "../axiosIn";

const Card = (props) => <Panel {...props} bordered></Panel>;

export const Main = () => {
  const [strava, setStrava] = useState("");
  const [ubica, setUbica] = useState("");
  const [fecRecon1, setFecRecon1] = useState("");
  const [fecRecon2, setFecRecon2] = useState("");
  const [horaRecon1, setHoraRecon1] = useState("");
  const [horaRecon2, setHoraRecon2] = useState("");
  const [fecCierre, setFecCierre] = useState("");
  const [horaCierre, setHoraCierre] = useState("");
  const [ruta1, setRuta1] = useState("");
  const [ruta2, setRuta2] = useState("");
  const [linkRuta1, setLinkRuta1] = useState("");
  const [linkRuta2, setLinkRuta2] = useState("");
  const [fechasRecon, setFechasRecon] = useState("");
  const [textoUbica, setTextoUbica] = useState("");
  const [cierraEvento, setCierraEvento] = useState(0);

  const getData = async () => {
    const abortController = new AbortController();
    var url = `DatosCarrera/getDataInicio`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      setStrava(response.data.Strava);
      setFecRecon1(response.data.FechaRecon1);
      setHoraRecon1(response.data.horaRecon1);
      setFecRecon2(response.data.FechaRecon2);
      setHoraRecon2(response.data.horaRecon2);
      setUbica(response.data.LinkUbicacion);
      setFecCierre(response.data.FechaCierre);
      setHoraCierre(response.data.HoraCierre);
      
      setFechasRecon(response.data.fechasRecon);
      setTextoUbica(response.data.TextUbicacion);
      setRuta1(response.data.Ruta1);
      setRuta2(response.data.Ruta2);
      setLinkRuta1(response.data.linkRuta1);
      setLinkRuta2(response.data.linkRuta2);
      setCierraEvento(response.data.CierreEvento);
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        console.log("Err_carga");
      }
    }
  };

  const speaker = (
    <Popover title="Rutas">
      <p>
        <a
          href={linkRuta1}
          style={{ fontSize: "18px" }}
          rel="noreferrer"
          target="_blank"
        >
          {ruta1}
        </a>
      </p>
      <p>
        <a
          href={linkRuta2}
          style={{ fontSize: "18px" }}
          rel="noreferrer"
          target="_blank"
        >
          {ruta2}
        </a>
      </p>
    </Popover>
  );

  const setCookie = (name, value, hours) => {
    document.cookie = `${name}=${value};`;
    document.cookie = `expira=${moment().add(hours, "h").format()};`;
    document.cookie = `sessionID=${crypto.randomUUID()};`;
  };

  const goTo = (page, windowOut) => {
    if (cierraEvento === 1) {
      window.location.href = "#/CierreEvento";
    } else {
      if (windowOut === 0) {
        window.location = `/#/${page}`;
      } else {
        window.open(page, "_blank");
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(Images/fondoRespon.jpg?v=${new Date().getTime()})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "98% 98%",
        backgroundPosition: "center",
        minHeight: "100%",
        height: "auto",
        position: "fixed",
        top: 0,
        height: "100%",
        width: "100%",
        overflow: "auto",
      }}
    >
      <div
        className="container"
        style={{
          margin: "auto",
          marginTop: "5%",
          width: "60%",
          marginLeft: "20%",
          padding: "10px",
        }}
      >
        <Header
          style={{
            backgroundColor: "#f9f7f6",
            height: "auto",
            padding: "20px",
            borderRadius: "15px",
            width: "auto",
            opacity: 0.9,
          }}
        >
          <div className="row mb-2">
            <div className="text-center col-lg-3 col-md-3 col-sm-3">
              <Card>
                <Link
                  to={"/DatosIniciales"}
                  style={{
                    color: "#008bf8",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Inscripciones
                </Link>
                <Image
                  src="/Images/bikers.jpg"
                  width={"150px"}
                  height={"70px"}
                  style={{ borderRadius: "10px", cursor: "pointer" }}
                  onClick={() => goTo("DatosIniciales", 0)}
                />
                <b style={{ color: "#008bf8" }}>Cierre de inscripciones</b>
                <br></br>
                <b style={{ color: "#008bf8" }}>
                  {fecCierre} {horaCierre}
                </b>
              </Card>
            </div>
            <div className="text-center col-lg-3 col-md-3 col-sm-3">
              <Card>
                <Whisper
                  placement="top"
                  trigger="hover"
                  controlId="control-id-hover-enterable"
                  speaker={speaker}
                  enterable
                >
                  <b style={{ color: "#008bf8" }}>Rutas</b>
                  <Image
                    src="/Images/strava.png"
                    width={"150px"}
                    height={"70px"}
                    style={{ borderRadius: "10px", cursor: "pointer" }}
                  />
                </Whisper>
                &nbsp;
                <a href={linkRuta1} target="_blank" rel="noreferrer">
                  <b style={{ color: "#008bf8" }}>{ruta1}</b>
                </a>
                <br></br>
                <a href={linkRuta2} target="_blank" rel="noreferrer">
                  <b style={{ color: "#008bf8" }}>{ruta2}</b>
                </a>
              </Card>
            </div>
            <div className="text-center col-lg-3 col-md-3 col-sm-3">
              <Card>
                <Link
                  to={ubica}
                  target="_blank"
                  style={{
                    color: "#008bf8",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Ubicación
                </Link>
                <Image
                  src="/Images/mapPoint.jpg"
                  width={"140px"}
                  height={"70px"}
                  style={{ borderRadius: "10px", cursor: "pointer" }}
                  onClick={() => goTo(ubica, 1)}
                />
                <b style={{ color: "#008bf8", fontSize: "14px" }}>
                  
                </b>
                <br></br>
                <b style={{ color: "#008bf8", fontSize: "12px" }}>
                  {textoUbica}
                </b>
              </Card>
            </div>
            <div className="text-center col-lg-3 col-md-3 col-sm-3">
              <Card>
                <Link
                  to={ubica}
                  target="_blank"
                  style={{
                    color: "#008bf8",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Reconocimiento(s)
                </Link>
                <Image
                  src="/Images/Recon1.jpg"
                  width={"155px"}
                  height={"70px"}
                  style={{ borderRadius: "10px", cursor: "pointer" }}
                  onClick={() => goTo(ubica, 1)}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <b style={{ color: "#008bf8" }}>8 y 15 de marzo</b>
                <br></br>
                <b style={{ color: "#008bf8" }}>Hora inicio: {horaRecon1}</b>
              </Card>
            </div>
          </div>
          <br></br>
          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  ACTIVAR PARA CONVOCATORIA <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          <div className="row mb-2">
            <div className="col text-center">
              {/* <Link><b>Dudas llamanos al: 444.225.2948</b></Link> */}
              <a
                href="Docs/ConvocaSerpiente.pdf"
                target="_blank"
                style={{
                  backgroundColor: "#f44336",
                  display: "block",
                  color: 'white',
                  textDecoration: 'none',
                  padding: '14px 25px',
                  borderRadius: '15px',
                  width: 'auto',
                }}
              >
                Convocatoria
              </a>
            </div>
          </div>
          <div className="row">
            <div className="text-center col">
              <Image
                src="/Images/Logo.png"
                width={"140px"}
                height={"90px"}
                style={{ borderRadius: "10px", cursor: "pointer" }}
                onClick={() => goTo("https://www.masmtb.com/", 1)}
              />
            </div>
          </div>
        </Header>
      </div>
    </div>
  );
};
